// extracted by mini-css-extract-plugin
module.exports = {"catContainer":"Category_catContainer__3i3Oe","cardContainer":"Category_cardContainer__3K8B2","catCard":"Category_catCard__1j4HA"};